import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const EMPTY_FILTERS = {
  name: '',
  email: '',
  phone_number: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({ isOpen, toggle, applyFilters, filters = {} }) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({ ...EMPTY_FILTERS, ...filters });

  useEffect(() => {
    if (isOpen) {
      setFiltersData({ ...EMPTY_FILTERS, ...filters });
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return (
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      lockScroll={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t("common.filter")}</h4>

        <FormGroup>
          <Label>{t("common.name")}</Label>
          <Input
            value={filtersData.name}
            onChange={(e) => setFiltersData({ ...filtersData, name: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.email")}</Label>
          <Input
            value={filtersData.email}
            onChange={(e) => setFiltersData({ ...filtersData, email: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.phone")}</Label>
          <Input
            value={filtersData.phone_number}
            onChange={(e) => setFiltersData({ ...filtersData, phone_number: e.target.value })}
          />
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t("common.addedAfter")}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({ ...filtersData, added_after: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.addedBefore")}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({ ...filtersData, added_before: e.target.value })}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{ marginBottom: '10px' }}>
          {t("common.filter")}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t("common.cancel")}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;
